/**
 * Formats variant options as "{Option name}: {Option value}, ..." using availableOptions order.
 */
export function formatVariantOptionsSummary({
  availableOptions = [],
  variantOptions = {},
}) {
  return availableOptions
    .map(({ name }) => {
      const value = variantOptions[name];
      if (value == null || value === '') {
        return null;
      }
      return `${name}: ${value}`;
    })
    .filter(Boolean)
    .join(', ');
}
